import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { NavigateFunction } from "react-router";

// GenerateQualidadeProcessosRiscosColumns

type Props = {
  onActionEditar: ( Id: number | null, openState: boolean) => void,
  onActionDeletar: ( Id: number | null, openState: boolean) => void,
  onActionCopiar: (Id: number | null, openState: boolean) => void,
  navigate: NavigateFunction;
};

export const GenerateQualidadeProcessosRiscosColumns = ({
  onActionEditar,onActionDeletar, onActionCopiar, navigate
}: Props): GridColDef[] => {

  return [
    {
      field: "Ano", 
      filterable: false,
      headerName: "Ano", 
      flex: 1,
      minWidth: 100,
      sortable: false,
    },
    {
      field: "Processo",
      filterable: false,
      headerName: "Processos",
      flex: 3,
      minWidth: 200,
      sortable: false,
      valueGetter: (_, row) => row['IdProcesso'] as number,
      renderCell: (params) => { 
          const processoId = params.value; 

          return (
              <Button
                onMouseDown={() => navigate(`/ProcessosRiscos_listaitens/${processoId}`)}
                sx={{
                    fontSize: 11,
                    paddingX: '.4rem',
                    paddingY: 0,
                    background: '#e6e6e6',
                    borderLeft: '.2rem solid #45b6af',
                    color: 'black',
                    fontWeight: 'normal',
                }}>
                Processos
              </Button>
          );
      },
    },
    {
    field: 'IdProcesso',
    sortable: false,
    filterable: false,
    headerName: 'Ações',
    width: 120,

    renderCell: (params) => {
      return (
        <div className="flex items-center justify-center w-full h-full gap-1">
          
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={22} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionCopiar(params.value, true)}>
              <DynamicIcon nameIcon="ContentCopyRounded" size={22} className="dark:text-white text-gray-500" />
            </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)} >
            <DynamicIcon nameIcon="DeleteForeverRounded" size={22} className="text-red-500" />
          </IconButton>

        </div>
      );
    }
    },
  ];
}